import axios from 'axios'

const defaultClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_V1,
  googleApiKey: process.env.GOOGLE_API_KEY,
  timeout: 10000
})

const v2Client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_V2,
  googleApiKey: process.env.GOOGLE_API_KEY,
  timeout: 10000
})

const clients = {
  default: {
    client: defaultClient
  },
  v2: {
    client: v2Client
  }
}

export default clients
